import {EventBus} from "../../EventBus";

export const handleDelete = () => {
    EventBus.emit('destroyInstance');
};